import { crystalTypes } from '../../core/gameConstants';
import { random } from '../../core/helpers/random';
import {
  SPINE_RESPONSE,
  PRE_BONUS_ID,
  WHEEL_ROTATION_STATE,
  ODD_CRYSTAL_ACTIVE_STATE,
} from '../../stateManagment/gameState';
import { crystalPerTypeHelper } from './CrystalPerTypeHelper';
import { BehaviorSubject } from '../../core/observer/BehaviorSubject';

export class SpinResponseHelper {
  constructor() {
    this.SPIN_STARTED = new BehaviorSubject(false);
    this.spinResponse = null;
    this.spinError = null;
  }

  getRandomNum(result) {
    const { length } = crystalPerTypeHelper.crystalPerType[result];
    const index = length > 1 ? random(0, length - 1) : 0;
    return crystalPerTypeHelper.crystalPerType[result][index];
  }

  notNull() {
    return SPINE_RESPONSE.getValue() !== null;
  }

  nullify() {
    SPINE_RESPONSE.next(null);
  }

  /**
   * @name setData
   * @param {Object} data
   * @param {string} data.demoBonusId
   * @param {number} data.result
   * @param {number} data.winAmount
   */
  setData(data) {
    SPINE_RESPONSE.next(data);
    if (data && (data.result === crystalTypes.crystal_gold || data.demoBonusId)) {
      PRE_BONUS_ID.next(data.demoBonusId);
    }
  }

  getData() {
    return SPINE_RESPONSE.getValue();
  }

  getRandomCrystal(type) {
    const { length } = crystalPerTypeHelper.crystalPerType[type];
    const index = length > 1 ? random(0, length - 1) : 0;
    return crystalPerTypeHelper.crystalPerType[type][index];
  }

  setCrystalPlace({ oldType, newType, index }) {
    const i = crystalPerTypeHelper.crystalPerType[oldType].findIndex(e => e === index);
    crystalPerTypeHelper.crystalPerType[oldType].splice(i, 1);
    crystalPerTypeHelper.crystalPerType[newType].push(index);
  }

  startSpin() {
    this.SPIN_STARTED.next(true);
  }

  stopSpin() {
    this.SPIN_STARTED.next(false);
  }

  setSpinStartedState(val) {
    this.SPIN_STARTED.next(val);
  }

  resetSpinStarted() {
    this.stopSpin();
  }

  get spinStarted() {
    return this.SPIN_STARTED.getValue();
  }

  get isStop() {
    return !this.SPIN_STARTED.getValue();
  }

  startWheelRotation() {
    WHEEL_ROTATION_STATE.next(true);
  }

  stopWheelRotation() {
    WHEEL_ROTATION_STATE.next(false);
  }

  disableOddCrystalActiveState() {
    ODD_CRYSTAL_ACTIVE_STATE.next(false);
  }

  enableOddCrystalActiveState() {
    ODD_CRYSTAL_ACTIVE_STATE.next(true);
  }

  get response() {
    return this.spinResponse;
  }

  setResponse(value) {
    this.spinResponse = value;
  }

  resetResponse() {
    this.spinResponse = null;
  }

  get hasError() {
    return this.spinError;
  }

  resetError() {
    this.spinError = null;
  }

  setError(error) {
    this.spinError = error;
  }
}

export const spinResponseHelper = new SpinResponseHelper();
